import { render, staticRenderFns } from "./chiefConsultantPage.vue?vue&type=template&id=b618b786&scoped=true&"
import script from "./chiefConsultantPage.vue?vue&type=script&lang=js&"
export * from "./chiefConsultantPage.vue?vue&type=script&lang=js&"
import style0 from "./chiefConsultantPage.vue?vue&type=style&index=0&id=b618b786&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b618b786",
  null
  
)

export default component.exports